import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";

import { environment } from '../../../../environments/environment';
import { Datamanagement } from "../shared/datamanagement.model";

@Injectable({
  providedIn: 'root'
})
export class DatamanagementService {

  constructor(private httpClient: HttpClient) { }

  dataManagement: Datamanagement;

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDLoan(FormValue: any) {
    console.log("CustomerSchemeId")
    console.log(FormValue.value.CustomerSchemeId)
    this.dataManagement = new Datamanagement();
    this.dataManagement.loan.ApplicationNo = FormValue.value.CustomerApplicationNo;
    this.dataManagement.loan.CustomerId = FormValue.value.CustomerNameId;
    this.dataManagement.loan.ApplicationDate = FormValue.value.CustomerLoanApprovedDate;
    this.dataManagement.loan.LoanTypeId = 1; //FormValue.value.LoanTypeId;
    this.dataManagement.loan.SchemeId = FormValue.value.CustomerSchemeId;
    this.dataManagement.loan.LoanAmount = FormValue.value.CustomerLoanAmount;
    this.dataManagement.loan.LoanPurposeId = FormValue.value.CustomerLoanPurpose;
    this.dataManagement.loan.IsJoint = 1; //IsJoint
    this.dataManagement.loan.JointLoanee = FormValue.value.WitnessId;
    this.dataManagement.loan.Remarks = "From Startup Entry/ Data Management";
    this.dataManagement.loan.AgentId = 0; // AgentId
    this.dataManagement.loan.LoanApprovedStatusId = 2; // Approved status
    this.dataManagement.loan.DDFund = FormValue.value.CustomerDDFund; // DDFund
    this.dataManagement.loan.LoanApprovedBy = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];

    this.dataManagement.loan.LoanApprovedDate = FormValue.value.CustomerLoanApprovedDate;  // need to change

    this.dataManagement.loan.IsActive = FormValue.value.IsActive;
    this.dataManagement.loan.Flag = FormValue.value.Flag;
    this.dataManagement.loan.PreSavingsAmount = FormValue.value.CustomerPreviousSavingsAmount;
    this.dataManagement.loan.IsOpening = FormValue.value.IsOpening;

    this.dataManagement.loan.CompanyId   = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.dataManagement.loan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.dataManagement.loan.EmployeeId   = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.dataManagement.loan.SaasId       = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.dataManagement.loan.CreatedDate  =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.dataManagement.loan.ModifiedDate =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = this.dataManagement.loan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/IUD', body, { headers: headers });
  }

   // it is calling form RECIEPT
   IUDLoantransaction(FormValue: any, LoanId : any) {
    
    this.dataManagement.loantransaction.Id = 0 
    this.dataManagement.loantransaction.LoanId = LoanId;
    this.dataManagement.loantransaction.TransactionNo = FormValue.value.CustomerTransactionNo;
    this.dataManagement.loantransaction.TransactionDate =    JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.dataManagement.loantransaction.CollectionAmount = ((FormValue.value.CustomerPrincipleAmount *1) + (FormValue.value.CustomerInterestAmount *1)) ;
    this.dataManagement.loantransaction.PrincipleAmount =  FormValue.value.CustomerPrincipleAmount;
    this.dataManagement.loantransaction.InterestAmount = FormValue.value.CustomerInterestAmount;
    this.dataManagement.loantransaction.InstallmentNo = FormValue.value.InstallmentNo;
    this.dataManagement.loantransaction.PaymentTypeId = 1;
    this.dataManagement.loantransaction.PaymentBankId = 0;
    this.dataManagement.loantransaction.ChequeNo = "00000000";
    this.dataManagement.loantransaction.Remarks = "From Startup Entry/ Data Management";
    this.dataManagement.loantransaction.IsActive = FormValue.value.IsActive;
    this.dataManagement.loantransaction.Flag = FormValue.value.Flag;
    this.dataManagement.loantransaction.IsOpening = FormValue.value.IsOpening; 
    // this.dataManagement.loantransaction.CollectionAmount = ((FormValue.value.PrincipleAmount *1) + (FormValue.value.loantransaction.InterestAmount *1)) ;
    
    this.dataManagement.loantransaction.CompanyId   = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.dataManagement.loantransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.dataManagement.loantransaction.EmployeeId   = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.dataManagement.loantransaction.SaasId       = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.dataManagement.loantransaction.CreatedDate  =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.dataManagement.loantransaction.ModifiedDate =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = this.dataManagement.loantransaction;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanTransaction/IUD', body, { headers: headers });
  }


  IUDSavings(FormValue: any) {

    const maturityDate = new Date(FormValue.value.CustomerSavingsDate);
    maturityDate.setFullYear(maturityDate.getFullYear() + 1);
    this.dataManagement = new Datamanagement();
    this.dataManagement.savings.Id = 0;
    this.dataManagement.savings.ApplicationNo = FormValue.value.CustomerApplicationNo;
    this.dataManagement.savings.DepositTypeId = FormValue.value.CustomerDepositTypeId;
    this.dataManagement.savings.CustomerId = FormValue.value.CustomerNameId;
    this.dataManagement.savings.MaturityDate = maturityDate;
    this.dataManagement.savings.InterestPayementType = FormValue.value.InterestPayementType;
    this.dataManagement.savings.JointCustomers = FormValue.value.JointCustomers;
    this.dataManagement.savings.DepositDate = FormValue.value.CustomerSavingsDate;
    this.dataManagement.savings.DepositAmount = FormValue.value.CustomerDepositAmount;
    this.dataManagement.savings.SchemeId = FormValue.value.CustomerDepositSchemeId;
    this.dataManagement.savings.NomineeName = "Nil";
    this.dataManagement.savings.NomineeRelationId = 0;
    this.dataManagement.savings.NomineeDOB = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.dataManagement.savings.RedemptionTypeId = 1;
    this.dataManagement.savings.AreaId = 0;
    this.dataManagement.savings.AgentId = 0;
    this.dataManagement.savings.Instructions = "Nil";
    this.dataManagement.savings.BankAccNo = "Nil";
    this.dataManagement.savings.BankName = "Nil";
    this.dataManagement.savings.BankBranch = "Nil";
    this.dataManagement.savings.IFSCCode = "Nil";
    this.dataManagement.savings.PaymentTypeId = 1;
    this.dataManagement.savings.PaymentBankId = 1;
    this.dataManagement.savings.ChequeNo = "Nil";
    this.dataManagement.savings.IsJoint = FormValue.value.IsJoint;
    this.dataManagement.savings.Remarks = "From Startup Entry/ Data Management";
    this.dataManagement.savings.IsActive = FormValue.value.IsActive;
    this.dataManagement.savings.Flag = FormValue.value.Flag;
    this.dataManagement.savings.PreSavingsAmount = FormValue.value.CustomerPreviousSavingsAmount;
    this.dataManagement.savings.IsOpening = FormValue.value.IsOpening;

    this.dataManagement.savings.CompanyId  = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.dataManagement.savings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.dataManagement.savings.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.dataManagement.savings.SaasId     = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.dataManagement.savings.CreatedDate   =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.dataManagement.savings.ModifiedDate  =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
  
    let body = this.dataManagement.savings   
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Savings/IUD', body, { headers: headers });
  }

  IUDSavingstransaction(FormValue: any, SavingsId : any) {
    
    this.dataManagement = new Datamanagement();
    this.dataManagement.savingstransaction.Id = 0 ;
    this.dataManagement.savingstransaction.SavingsId = SavingsId;
    this.dataManagement.savingstransaction.TransactionNo = FormValue.value.CustomerTransactionNo;
    this.dataManagement.savingstransaction.TransactionDate = JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.dataManagement.savingstransaction.PrincipleAmount = FormValue.value.CustomerSavingsPrincipleAmount;
    this.dataManagement.savingstransaction.InterestAmount = FormValue.value.CustomerSavingsInterestAmount;
    this.dataManagement.savingstransaction.InstallmentNo = 1;
    this.dataManagement.savingstransaction.IsPartPayment = false;
    this.dataManagement.savingstransaction.IsPreclosure = false;
    this.dataManagement.savingstransaction.PaymentTypeId = 1
    this.dataManagement.savingstransaction.PaymentBankId = 1
    this.dataManagement.savingstransaction.ChequeNo = "Nil";
    this.dataManagement.savingstransaction.Remarks ="From Startup Entry/ Data Management";
    this.dataManagement.savingstransaction.IsAccruedAmount = false;
    this.dataManagement.savingstransaction.IsSavingsclosed = false;
    this.dataManagement.savingstransaction.IsActive = FormValue.value.IsActive;
    this.dataManagement.savingstransaction.Flag = FormValue.value.Flag;
    this.dataManagement.savingstransaction.IsOpening = FormValue.value.IsOpening;

    this.dataManagement.savingstransaction.CompanyId  = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.dataManagement.savingstransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.dataManagement.savingstransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.dataManagement.savingstransaction.SaasId     = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.dataManagement.savingstransaction.CreatedDate  =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.dataManagement.savingstransaction.ModifiedDate =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = this.dataManagement.savingstransaction;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsTransaction/IUD', body, { headers: headers });
  }

  IUDCentreLink(FormValue: any) {

    this.dataManagement = new Datamanagement();
    this.dataManagement.centerlink.CentreId = FormValue.value.CustomerCentreId;
    this.dataManagement.centerlink.GroupId = FormValue.value.CustomerGroupId;
    this.dataManagement.centerlink.CustomerId = FormValue.value.CustomerNameId;
    this.dataManagement.centerlink.AdmissionFee = FormValue.value.CustomerAdmissionFee;
    this.dataManagement.centerlink.IsActive = FormValue.value.IsActive;
    this.dataManagement.centerlink.Flag = FormValue.value.Flag;

    this.dataManagement.centerlink.CompanyId  = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.dataManagement.centerlink.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.dataManagement.centerlink.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.dataManagement.centerlink.SaasId = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    this.dataManagement.centerlink.CreatedDate  =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    this.dataManagement.centerlink.ModifiedDate =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    let body = this.dataManagement.centerlink;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CenterLink/IUD', body, { headers: headers });
  }
}
